// extracted by mini-css-extract-plugin
export default {"clientsFooter":"styles_clientsFooter__2SyvD","actions":"styles_actions__31uWH","btn":"styles_btn__qVgvc","share":"styles_share__-TZuu"};